import { Component, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LucideAngularModule } from 'lucide-angular';

export interface ErrorDialogData {
	title?: string;
	message?: string;
}

@Component({
	selector: 'app-error-dialog',
	standalone: true,
	imports: [MatButtonModule, LucideAngularModule],
	templateUrl: './error-dialog.html',
	styleUrl: './error-dialog.scss'
})
export class ErrorDialogComponent {
	title: string;
	message: string | null;

	constructor(
		public dialogRef: MatDialogRef<ErrorDialogComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) data: ErrorDialogData | string | null
	) {
		const normalized = typeof data === 'string' ? { message: data } : data;
		this.title = normalized?.title ?? 'No pudimos completar el registro';
		this.message = normalized?.message ?? null;
	}

	cerrar(): void {
		this.dialogRef.close();
	}
}
